import { LineVertical, Notepad, TerminalWindow } from '@phosphor-icons/react';
import { Mode } from '../stores/HomeStore';

interface ModeToggleProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

export const ModeToggle = ({ mode, setMode }: ModeToggleProps) => {
  return (
    <div className="pb-2 flex justify-start">
      <button
        className={
          mode === 'terminal'
            ? 'text-neutral-900 dark:text-neutral-100'
            : 'text-neutral-400 dark:text-neutral-500'
        }
        onClick={() => setMode('terminal')}
      >
        <TerminalWindow size={22} />
      </button>

      <LineVertical size={22} />

      <button
        className={
          mode === 'notebook'
            ? 'text-neutral-900 dark:text-neutral-100'
            : 'text-neutral-400 dark:text-neutral-500'
        }
        onClick={() => setMode('notebook')}
      >
        <Notepad size={22} />
      </button>
    </div>
  );
};
